import React, { useEffect, useState } from "react";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import MyCarousel from "./../Carousel/Carousel";
import Card from "./../CardMain/CardMain";
import { Link } from "react-router-dom";
import imageConsignacion from "../../assets/image/mainCards/renault-stepwaybordo.jpg";
import imageVentaDirecta from "../../assets/image/mainCards/Renegade_Sport.webp";
import imageVendeMientrasUsas from "../../assets/image/mainCards/YarisBlanco.webp";
import image0km from "../../assets/image/mainCards/bydpro.jpg";
import imageUsados from "../../assets/image/mainCards/208-blanco.png";
import WhatsApp from "../WhatsApp/WhatsApp";
import CommentsCarousel from "../Comments/CommentsCarousel";

const Main = () => {
  const [vehicleData, setVehicleData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const storage = getStorage();
        const newVehicles = await fetchVehiclesFromFolder(storage, "nuevo", 3);
        const usedVehicles = await fetchVehiclesFromFolder(storage, "Usados", 6);

        setVehicleData([...newVehicles, ...usedVehicles]);
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVehicleData();
  }, []);

  const fetchVehiclesFromFolder = async (storage, folder, limit) => {
    const folderRef = ref(storage, `Autos/${folder}`);
    const response = await listAll(folderRef);
    let vehicles = [];

    for (const subfolder of response.prefixes) {
      const subfolderResponse = await listAll(subfolder);
      
      // Buscar la imagen principal (1.jpg)
      const imageFile = subfolderResponse.items.find(
        (item) => item.name === "1.jpg"
      ) || subfolderResponse.items.find(
        (item) => !item.name.endsWith(".json")
      );

      // Buscar el archivo JSON
      const jsonFile = subfolderResponse.items.find(
        (item) => item.name.endsWith(".json")
      );

      if (imageFile) {
        const imageUrl = await getDownloadURL(imageFile);
        let vehicleInfo = {
          url: imageUrl,
          name: subfolder.name, // Nombre de la carpeta
          type: folder, // "nuevo" o "Usados"
          folderName: subfolder.name
        };

        // Si hay JSON, obtener los datos del vehículo
        if (jsonFile) {
          try {
            const jsonUrl = await getDownloadURL(jsonFile);
            const jsonResponse = await fetch(jsonUrl);
            const jsonData = await jsonResponse.json();
            
            vehicleInfo = {
              ...vehicleInfo,
              marca: jsonData.Marca,
              modelo: jsonData.Modelo,
              year: jsonData.Año,
              price: jsonData.Precio, // Si tienes precio
              name: `${jsonData.Marca} ${jsonData.Modelo}` // Nombre completo
            };
          } catch (error) {
            console.error("Error fetching JSON for", subfolder.name, error);
          }
        }

        vehicles.push(vehicleInfo);
      }

      if (vehicles.length >= limit) {
        break;
      }
    }

    return vehicles;
  };

  const handleVehicleClick = (vehicle) => {
    // Navegar a la página del vehículo usando el tipo y el nombre de la carpeta
    navigate(`/${vehicle.type}/${vehicle.folderName}`);
  };

  const LoadingSpinner = () => (
    <div className="flex items-center justify-center py-20">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-gray-300 border-t-gray-700 rounded-full animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 bg-gray-700 rounded-full animate-pulse"></div>
        </div>
      </div>
      <span className="ml-4 text-xl font-medium text-gray-600 animate-pulse">
        Cargando vehículos...
      </span>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300">
      
      <div className="container mx-auto px-4 pt-2 pb-6">
        
        {/* COMPRAR Section - DESTACADA */}
        <section className="py-16 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded-3xl shadow-xl -mt-2 mb-16 border border-gray-300">
          <div className="text-center mb-12">
            <div className="inline-flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-r from-gray-700 to-gray-900 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span className="text-lg font-semibold text-gray-700 uppercase tracking-wide">Lo más buscado</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              ¿Necesitás Comprar?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Descubrí nuestra selección premium de vehículos nuevos y usados de la más alta calidad
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto px-8">
            <div className="group">
              <Link to="/0km" className="block h-full">
                <div className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200 bg-white h-full">
                  <div className="absolute inset-0 bg-gradient-to-br from-gray-600/10 to-gray-800/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl z-10 pointer-events-none"></div>
                  <div className="relative z-20 h-full">
                    <Card title="0 KM" image={image0km} />
                  </div>
                </div>
              </Link>
            </div>
            
            <div className="group">
              <Link to="/usados" className="block h-full">
                <div className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200 bg-white h-full">
                  <div className="absolute inset-0 bg-gradient-to-br from-gray-500/10 to-gray-700/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl z-10 pointer-events-none"></div>
                  <div className="relative z-20 h-full">
                    <Card title="USADOS SELECCIONADOS" image={imageUsados} />
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* Our Cars Section */}
        <section className="py-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Nuestros Vehículos Disponibles
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Explorá toda nuestra gama de vehículos en stock
            </p>
          </div>
          
          <div className="bg-gray-100 rounded-3xl shadow-xl p-8 backdrop-blur-sm border border-gray-300">
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <MyCarousel 
                autoSlide={true} 
                items={vehicleData}
                onItemClick={handleVehicleClick}
              />
            )}
          </div>
        </section>

       <section className="py-12">
  <div className="text-center mb-10">
    <span className="text-lg font-semibold text-gray-700 uppercase tracking-wide mb-2 block"></span>
    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
      Vende tu auto
    </h2>
    <p className="text-lg text-gray-600 max-w-xl mx-auto">
      Ofrecemos las mejores opciones para que vendas tu vehículo
    </p>
  </div>
  
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto">
    <div className="group">
      <Link to="/consignacion" className="block h-full">
        <div className="relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-200 h-full">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-600/5 to-gray-800/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <Card title="DEJA TU AUTO EN CONSIGNACION" image={imageConsignacion} />
        </div>
      </Link>
    </div>
    
    <div className="group">
      <Link to="/compradirecta" className="block h-full">
        <div className="relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-200 h-full">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-500/5 to-gray-700/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <Card title="COMPRAMOS TU AUTO YA" image={imageVentaDirecta} />
        </div>
      </Link>
    </div>
    
    <div className="group">
      <Link to="/VendeMientrasUsas" className="block h-full">
        <div className="relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-200 h-full">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-600/5 to-gray-800/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <Card title="VENDELO MIENTRAS LO USAS" image={imageVendeMientrasUsas} />
        </div>
      </Link>
    </div>
  </div>
</section>

        {/* References Section */}
        <section className="py-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Nuestras Referencias
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Lo que dicen nuestros clientes sobre nosotros
            </p>
          </div>
          
          <div className="bg-gradient-to-r from-gray-200 to-gray-300 rounded-3xl shadow-xl p-8 border border-gray-300">
            <div className="max-w-7xl mx-auto">
              <CommentsCarousel autoSlide={true} />
            </div>
          </div>
        </section>
        
      </div>
      
      <WhatsApp />
    </div>
  );
};

export default Main;